import React, { useCallback, useMemo } from 'react';
import { observer } from 'mobx-react';
import { Button } from 'ksnm-common-ui/lib/Button';
import { Icon } from 'ksnm-common-ui/lib/Icon';
import { Select } from 'ksnm-common-ui/lib/Select';
import { sortBy, uniqBy } from 'lodash-es';

import { controlsStore } from '@stores/dictionaryStores/controlsStore/controlsStore';
import { controlVersionsStore } from '@stores/dictionaryStores/controlVersionsStore/controlVersionsStore';
import { reportGroupsStore } from '@stores/dictionaryStores/reportGroupsStore/reportGroupsStore';

import styles from './Filter.module.scss';

export const Filter = observer((): JSX.Element => {
  const { setFilters, filters, setSelectNode, setSelectedKeys } = controlVersionsStore;
  const { controls } = controlsStore;
  const { reportGroups } = reportGroupsStore;

  const onClear = useCallback(() => {
    setFilters({});
    setSelectNode(null);
    setSelectedKeys([]);
  }, [setFilters, setSelectNode, setSelectedKeys]);

  const onChangeReportGroup = useCallback(
    (v) => {
      setFilters({ reportGroup: v });
      setSelectNode(null);
      setSelectedKeys([]);
    },
    [setFilters, setSelectNode, setSelectedKeys],
  );

  const reportGroupItems = useMemo(
    () =>
      sortBy(
        uniqBy(
          controls.filter((item) => !!item.repGroupCode),
          'repGroupCode',
        ).map((control) => {
          const group = reportGroups.find((item) => item.code === control.repGroupCode);
          return {
            id: control.repGroupCode,
            name: group ? `${group.code} - ${group.name}` : '',
          };
        }),
        'name',
      ),
    [controls, reportGroups],
  );

  return (
    <div className={styles.designFilters}>
      <div className={styles.items}>
        <Select
          items={reportGroupItems}
          placeholder="Группа отчета"
          value={filters.reportGroup}
          onChange={onChangeReportGroup}
          size="small"
          showSearch
          className={styles.select}
        />
      </div>

      <Button onClick={onClear} disabled={!filters.reportGroup} icon={<Icon name="stop" />}>
        Сбросить фильтры
      </Button>
    </div>
  );
});
